import React from 'react'
import { ImageProps } from './types'
import styled from 'styled-components'
import NoIcon from 'assets/images/app-no-icon.png'

const SmallImage = styled.img.attrs((props: any) => ({
    size: props.size || '24px',
}))`
    height: ${props => props.size};
    width: ${props => props.size};
`

export const SizableImage = (props: ImageProps) => (
    <SmallImage
        src={String(props.url)}
        data-src={props.dataSrc}
        onError={props.onError}
        size={props.size}
        className={props.className}
    />
)

export const Image = (props: ImageProps) => (
    <img src={String(props.url)} alt="Image not exists" />
)

export const AppNoIcon = (small?: boolean) =>
    small ? <SmallImage src={NoIcon} /> : <img src={NoIcon} alt="No icon" />
